<template>
 <ul class="sidebar-menu">
   <li class="header">Áreas</li>
   <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Principal</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/manutencao">
      <a>
        <i class="fa ion-android-settings"></i>
        <span class="page">Manutenção</span>
      </a>
    </router-link>
    <li class="treeview">
      <a href="#">
        <i class="fa ion-stats-bars"></i>
        <span>Gráficos</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-gerais">
              <a>
                <span class="page"> Gerais</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-material">
              <a>
                <span class="page"> Material</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/graficos-acumulados">
              <a>
                <span class="page"> Acumulados por dia</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
    </li>
   <router-link tag="li" class="pageLink" to="/usuario">
     <a>
       <i class="fa fa-user"></i>
       <span class="page">Usuário</span>
     </a>
   </router-link>
   <router-link tag="li" class="pageLink" to="/logout">
     <a>
       <i class="fa fa-sign-out"></i>
       <span class="page">Sair</span>
     </a>
   </router-link>
 </ul>
</template>
<script>
export default {
  name: 'SidebarMenu'
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?89adc2ac